var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chatbot__user-message",style:(_vm.style)},[_c('div',{staticClass:"chatbot__user-message__text"},[_c('div',[_vm._v(_vm._s(_vm.localSettings.message || 'Add Message'))])])])}
var staticRenderFns = []

export { render, staticRenderFns }